import Vue from 'vue'
import Router from 'vue-router'
import Albums from '@/components/Albums'
import AlbumDetail from '@/components/AlbumDetail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Albums',
      component: Albums
    },
    {
      path: '/album',
      name: 'AlbumDetail',
      component: AlbumDetail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js